import React, { useEffect, useState  } from "react";
import { Link,useParams ,useLocation,useNavigate} from "react-router-dom"; 
import Header from "./Front/Header";
import Footer from "./Front/Footer"; 
import API_BASE_URL from "../Config"; 
import { v4 as uuidv4 } from "uuid";

import { toast } from "react-toastify";
import "../styles/global.css";

const FrontBookingConfirmed = () => { 
   const location = useLocation();
const doctor_id = location.state?.doctor_id; 
const booking_date = location.state?.booking_date;
const patientName = location.state?.patient_name;  
const mobile = location.state?.mobile; 
console.log(doctor_id,patientName,mobile);
   
  return (
    <>
       <Header  /> 

           <section className="py-xl-5 py-3">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <nav
            
            aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item"><a href="index.html">Home</a></li>
              <li className="breadcrumb-item active" aria-current="page">Booking Confirmed</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </section>
  <div className="container">
    <div className="row">
      <div className="col-10">
          <div className="confirm-wrapper my-3 ">
            <div className="confirm-card">

              <h2 className="confirm-title">
                <i className="fa-solid fa-circle-check"></i>
                Appointment Confirmed
              </h2>

              <p className="confirm-desc">
                Your appointment ID is <strong>23282385</strong><br/>
                We have sent you an email and SMS with the details.
              </p>

              <div className="confirm-details">
                <div className="detail-item">
                  <label>Patient Name</label>
                  <p>{patientName}</p>
                </div>
 

                <div className="detail-item">
                  <label>Mobile</label>
                  <p>{mobile}</p>
                </div>
              </div>

              {/* <div className="confirm-actions d-inline-flex gap-3 flex-wrap">
                <button className="dc-book-btn">Cancel Appointment</button> 
              </div> */}

            </div>
           </div>

      </div>
    </div>
  </div>
 
       <Footer/>
    </>
  );
};

export default FrontBookingConfirmed;
